<!------------------------------------------------------------------------------
 File: BaseInputWithIcon 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-07
 Time: 13:54
------------------------------------------------------------------------------->
<template>
    <div class="md-form"
         v-tooltips-enabled="{
                        active:tooltip,
                        title:title
                    }"
    >
        <BaseIcon
                class="material-icons prefix"
                :content="icon"
        ></BaseIcon>
        <template>

            <input :id="id"
                   :name="field"
                   step="any"
                   :max="max"
                   autocomplete="off"
                   class="form-control"
                   :maxlength="maxlength"
                   :class="[{
    'is-invalid':error,
        'error':invalid,
        'invalid':invalid,
                   },cls]"
                   :tabindex="tabindex"
                   :type="input_type === 'money'?'number':input_type"
                   :value="input_value"
                   v-model="input_value"
                   :novalidate="novalidate"
                   @keyup="stripTheGarbage($event)"
                   @blur="formatInput()"
            >
        </template>

        <label :for="id"
               :data-error="data_validation_msg.error"
               :data-right="data_validation_msg.correct"
               class="text-sentence">{{label}}</label>
    </div>
</template>

<script>
    import Vue from 'vue';
    import vueTooltip from './tooltip/vueTooltip';

    Vue.use(vueTooltip);

    export default {
        name: "BaseInputWithIcon",
        components: {},
        props: {
            data_validation_msg: {
                type: Object,
                default: () => {
                    return {
                        error: 'wrong',
                        correct: null
                    }

                }
            },
            novalidate: {
                type: Boolean,
                default: false
            },
            maxlength: {
                type: Number,
                default: null
            },
            icon: {
                type: String,
                default: 'title'
            },
            max: {
                type: String,
                default: '100000.00'
            },
            identifier: {
                type: String,
                default: ''
            },
            cls: {
                type: String
            },
            input_class: {
                type: String,
                default: null
            },
            icon_class: {},
            id: {
                type: String
            },
            field: {
                type: String,

            },
            required: {
                type: Boolean,
                default: false
            },
            tabindex: {
                type: Number,
                default: 0
            },
            label: {
                type: String,
                default: 'Name'
            },
            input_type: {
                type: String,
                default: 'text'
            },
            title: {
                type: String
            },
            tooltip: {
                type: Boolean,
                default: true
            },
            value: {
                type: String | Number
            },
            error: {
                type: Boolean,
                default: false
            },
            invalid: {
                type: Boolean,
                default: false
            },
            /**
             * @param {object} strip_types
             * @param {object} strip_types.alpha    strips all non alpha
             * @param {object} strip_types.numeric    strips all non numeric
             */
            valid_types: {
                type: String,
                default: null
            },

        },
        mounted() {
            // console.log('this.value != blank',typeof this.value,'length', this.value.length,'val', this.value, 'label', this.label);

            if (typeof this.value == 'string' && this.value.length > 0 ||
                typeof this.value == 'number' && this.value > 0
            ) {
                this.input_value = this.value;
                // if (this.input_type == 'money') {
                //     this.formatMoney();
                // }
            }
        },
        data() {
            return {
                input_value: '',
                alphaExp: /^[a-zA-Z]+$/
            }
        },
        watch: {
            input_value() {
                if (this.error) {
                    this.$emit('form_error', {
                        id: this.identifier,
                        value: false
                    });
                }
            },
            value(value) {
                this.input_value = value;
            }
        },
        methods: {

            stripTheGarbage(event) {
                if (this.input_type === 'money') {
                    if (event.keyCode < 48 && event.keyCode !== 46 || event.keyCode > 59) {
                        event.preventDefault()
                    }
                } else {
                    if (this.valid_types !== null) {
                        let value = event.target.value;

                        if (this.valid_types === 'alphanumeric') {
                            value = value.replace(/[^A-Za-z0-9]+/g, '');
                        } else if ('alpha' in this.valid_types) {
                            value = value.replace(/[^A-Za-z]+/g, '');
                        } else if ('numeric' in this.valid_types) {
                            value = value.replace(/[^0-9]+/g, '');
                        }
                        this.input_value = value;

                    }

                    // console.log('this.input_value', this.input_value)
                    this.$emit('keyup', this.input_value);
                }
            },
            countDecimals(value) {
                if (Math.floor(value) === value) {
                    return 0;
                }
                return value.toString().split(".")[1].length || 0;
            },
            formatMoney() {
                let num = this.input_value;
//                 num = Number(num);
//
//                 let decimal = this.countDecimals(num);
// // console.log(decimal);
//
//                 if (decimal < 2) {
//                     num = num.toFixed(2)
//                 }
//
//                 if (decimal > 2) {
//                     num = num.toFixed(decimal)
//                 }
//
//                 if (parseInt(num) < 1) {
//                     num = "." + String(num).split(".")[1];
//                 }
                return num;
            },
            formatInput() {
                if (this.input_value !== '') {
                    if (this.input_type === 'money') {
                        this.input_value = this.formatMoney();
                    }
                }
                // console.log('this.input_type', this.input_type);

                this.$emit('input_value', this.input_value);
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseInputWithIcon.vue